import { GetInTouchConst } from "../Constants/GetInTouchConstants";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";
import { handleAuthError } from "../../utils/authUtils";

const buildHeaders = () => {
  const token = localStorage.getItem("accessToken");
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", `Bearer ${token}`);
  return headers;
};

export const FetchAllGetInTouchQueries = () => {
  return async (dispatch) => {
    dispatch({ type: GetInTouchConst.FETCH_ALL_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.GET_IN_TOUCH_QUERIES}`, {
      method: "GET",
      headers: buildHeaders(),
      redirect: "follow",
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200) {
          dispatch({ type: GetInTouchConst.FETCH_ALL_SUCCESS, result });
        } else {
          dispatch({ type: GetInTouchConst.FETCH_ALL_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: GetInTouchConst.FETCH_ALL_FAIL,
          result: { statusCode: 500, message: error.message },
        });
      });
  };
};

export const ClearGetInTouchAction = () => ({ type: GetInTouchConst.CLEAR_ACTION });
